import { render } from "./updateAlert.vue?vue&type=template&id=9050a7be"
import script from "./updateAlert.vue?vue&type=script&lang=js"
export * from "./updateAlert.vue?vue&type=script&lang=js"

import "./updateAlert.vue?vue&type=style&index=0&id=9050a7be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__